module.exports = __webpack_public_path__ + "static/img/partner8.19c8737.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/partner8.png
// module id = d9O7
// module chunks = 8